import React, { useEffect } from 'react';

import { useMutation } from '@apollo/client';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';

import opportunityAssigmentRequest from '../../../services/opportunityAssigment/gqlSchema';

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: '100%',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const SelectLeadStatut = ({ opportunityAssignment }) => {
  const classes = useStyles();

  const [leadStatut, setLeadStatut] = React.useState(opportunityAssignment.leadStatut || 'TO_CONTACT');

  const [updateleadStatut, { loading, error }] = useMutation(opportunityAssigmentRequest.Mutation.setStatutLead, {
    variables: {
      opportunityAssignmentId: opportunityAssignment.id,
      statutLead: { leadStatut },
    },
  });

  useEffect(() => {
    if (leadStatut !== opportunityAssignment.leadStatut && !loading) {
      updateleadStatut().catch(e => console.error(e));
    }
  }, [leadStatut, loading, opportunityAssignment, updateleadStatut]);

  if (error) {
    console.error(error);
  }

  const handleChange = event => {
    setLeadStatut(event.target.value);
  };

  return (
    <FormControl className={classes.formControl}>
      <InputLabel id='label-select-statut-lead'>Statut</InputLabel>
      <Select labelId='label-select-statut-lead' id='select-statut-lead' value={leadStatut} onChange={handleChange}>
        <MenuItem value='TO_CONTACT'>A contacter</MenuItem>
        <MenuItem value='UNREACHABLE'>Injoignable</MenuItem>
        <MenuItem value='WRONG_NUMBER'>Faux numéro</MenuItem>
        <MenuItem value='NOT_INTERRESTED'>Pas intéressé</MenuItem>
        <MenuItem value='TO_CONTACT_LATER'>A recontacter plus tard</MenuItem>
        <MenuItem value='WANTS_APPOINTMENT'>Souhait RDV</MenuItem>
        <MenuItem value='VALUE_REPORT_COMPLETED'>Avis de valeur réalisé</MenuItem>
        <MenuItem value='MANDATE_SIGNED'>Mandat signé</MenuItem>
      </Select>
    </FormControl>
  );
};

export default SelectLeadStatut;
